/*jshint esversion: 11 */

const navLinks = document.querySelectorAll(".nav-item");
const menuToggle = document.getElementById("navbarSupportedContent");
const bsCollapse = new bootstrap.Collapse(menuToggle, { toggle: false });
navLinks.forEach((l) => {
  l.addEventListener("click", () => {
    bsCollapse.toggle();
  });
});

document.querySelectorAll("a.nav-link").forEach(link => {
  link.addEventListener("click", e => {

    const target = document.querySelector(link.hash);
    if (!target) return;

    e.preventDefault();

    const nav = document.querySelector(".navbar");

    const offset =
      nav.getBoundingClientRect().top +
      nav.getBoundingClientRect().height;

    const top =
      target.getBoundingClientRect().top +
      window.scrollY -
      offset;

    window.scrollTo({
      top,
      behavior: "smooth"
    });

  });
});

document.addEventListener("DOMContentLoaded", function () {
  const navBar = document.querySelector("nav.navbar");

  function updateBackgroundGradient() {
    const scrollTop = window.scrollY;

    navBar.classList.toggle("rolling", scrollTop > 52);
  }

  window.addEventListener("scroll", updateBackgroundGradient);
});
